import type { App } from 'vue'
import ToastService from 'primevue/toastservice'

export function registerPrimeVueToast(app: App) {
  app.use(ToastService)
}
